// src/components/GuestFormModal.js

import { Phone, User } from 'lucide-react';
import React, { useState } from 'react';
import {
  Modal,
  Offcanvas,
  Button,
  Form,
  Row,
  Col,
  InputGroup,
} from 'react-bootstrap';

const GuestFormModal = ({ show, handleClose, guestList, setGuestList }) => {
  const isMobile = window.innerWidth < 768;
  const [guest, setGuest] = useState({ name: '', phone: '' });
  const [error, setError] = useState('');

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setGuest((prev) => ({ ...prev, [name]: value }));
  };

  const handleAddGuest = () => {
    if (!guest.name || !guest.phone) {
      setError('Please fill in all fields');
      return;
    }
    setGuestList([...guestList, guest]);
    setGuest({ name: '', phone: '' });
    setError('');
    handleClose();
  };

  const Content = (
    <>
      <div className="p-3">
       
        <Form>
          <Row className="mb-3">
            <Col md={12}>
              <Form.Label>Name</Form.Label>
              <InputGroup>
              <InputGroup.Text><User size={16} /></InputGroup.Text>
              <Form.Control
                type="text"
                name="name"
                value={guest.name}
                onChange={handleInputChange}
                placeholder="Enter guest name"
                required
               
              />
              </InputGroup>
            </Col>
          </Row>
          <Row className="mb-3">
            <Col md={12}>
              <Form.Label>Phone</Form.Label>

            <InputGroup>
                    <InputGroup.Text><Phone size={16} /></InputGroup.Text>
              <Form.Control
                type="tel"
                name="phone"
                value={guest.phone}
                onChange={(e) => {
                  let val = e.target.value;
        
                  // Allow only + at the start and digits after
                  if (val.startsWith("+")) {
                    val = "+" + val.slice(1).replace(/[^0-9]/g, "");
                  } else {
                    val = val.replace(/[^0-9]/g, "");
                  }
        
                  // Limit to 13 characters max
                  if (val.length > 13) val = val.slice(0, 13);
        
                  handleInputChange({ target: { name: "phone", value: val } });
                }}
                placeholder="Enter phone number"
                required
                inputMode="numeric"
                pattern="^\+?[0-9]{10,13}$"   // ✅ regex: optional +, 10–13 digits
                minLength={10}
                maxLength={13}
              />
              </InputGroup>
            </Col>
          </Row>
          {error && <p className="text-danger small">{error}</p>}
          <Button  onClick={handleAddGuest} className="w-100 btn-own">
            Save Guest
          </Button>
        </Form>
      </div>
    </>
  );

  return isMobile ? (
    <Offcanvas show={show} onHide={handleClose} placement="bottom"  style={{ borderTopLeftRadius: 20, borderTopRightRadius: 20,height:'auto' }}>
      <Offcanvas.Header closeButton>
        <Offcanvas.Title>Add Guest</Offcanvas.Title>
      </Offcanvas.Header>
      <Offcanvas.Body>{Content}</Offcanvas.Body>
    </Offcanvas>
  ) : (
    <Modal show={show} onHide={handleClose} centered>
      <Modal.Header closeButton>
        <Modal.Title>Add Guest</Modal.Title>
      </Modal.Header>
      <Modal.Body>{Content}</Modal.Body>
    </Modal>
  );
};

export default GuestFormModal;
